import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Icon,
  Grid
} from '@material-ui/core';
import { deleteSubscriptionBenefitApi } from 'api/subscription';


export default ({title = '', benefitItems, handleEdit}) => {
  const dispatch = useDispatch();

  if (!benefitItems?.length) {
    return null;
  }

  return (
    <Card className="mb-4">
      <CardContent>
        <Typography variant="h3">
          {title}
        </Typography>
      </CardContent>
      <Grid container spacing={3} alignItems="center" className="ml-4 pl-4">
        {benefitItems.map((benefitItem) => (
          <>
            <Grid key={benefitItem._id} item sm={8}>
              <Typography className="h4">
                {benefitItem.title}
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <IconButton
                className="mr-2"
                title="Edit"
                onClick={() => handleEdit(benefitItem)}
              >
                <Icon className="text-gray">edit</Icon>
              </IconButton>
            </Grid>
            <Grid item sm={2}>
              <IconButton
                className="mr-2"
                title="Delete"
                onClick={() => deleteSubscriptionBenefitApi({dispatch, item: benefitItem})}
              >
                <Icon className="text-gray">delete</Icon>
              </IconButton>
            </Grid>
          </>
        ))}
      </Grid>
    </Card>
  );
};
